import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import TransactionsCard from '../components/TransactionsCard';
import TrTable from '../components/TrTable';

const Transactions = () => {
    return (
        <div className="d-flex entire-bg-color">
            <Sidebar />
            <DashboardNavbar />
            <div className="flex-grow-1">

                <TransactionsCard />
                <TrTable />


            </div>
        </div>
    );
};

export default Transactions;